import React from 'react'
import { Slide, ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { isRTL } from '@s4l/utils/library/rtl'

import { useAlert } from 'src/hooks/useAlert'
import IconClose from 'client/icons/Close'

import styles from './styles.module.css'

interface IAlertMessageContainer {
  containerId?: string
}

const AlertMessageContainer = ({ containerId }: IAlertMessageContainer) => {
  useAlert({ containerId })

  return (
    <ToastContainer
      className={styles.toastOverride}
      containerId={containerId}
      enableMultiContainer
      position="top-center"
      newestOnTop
      closeOnClick
      draggable
      pauseOnHover
      theme="colored"
      transition={Slide}
      rtl={isRTL()}
      closeButton={<IconClose size={16} />}
    />
  )
}

export default AlertMessageContainer
